module.exports = __webpack_public_path__ + "static/media/banner2.99d565b8.png";